import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import { orderActions } from "../../../../../store/orders-slice"

const Resort = (props) => {
       const { type, name } = props
       const { resort } = useFilter()
       
       let filteredorders = useSelector((state) => state.order.filteredOrders)
       let orders=useSelector(state=>state.order.orders)
       let dispatch = useDispatch()
   
       return <Fragment>
           <label>{name}</label><select className="mb-2"
               onChange={(event) => {
                   let value = event.target.value
   
                   switch (value) {
                       case 'ASC':
                           dispatch(orderActions.setFilteredItems(resort(filteredorders??orders, type, 'ASC')))
                           break
   
                       case 'DESC':
                           dispatch(orderActions.setFilteredItems(resort(filteredorders??orders, type, 'DESC')))
                           break
                   }
   
               }}
   
           >
               <option value='' >Sort</option>
               <option value='ASC' >Ascending</option>
               <option value='DESC' >Descending</option>
           </select>
       </Fragment>
}

export default Resort